import { FeatureLabsPage } from './feature-labs';

export default function SettingsFeatureLabsPage() {
  return (
    <div className="h-full overflow-auto">
      <FeatureLabsPage />
    </div>
  );
}
